import React from 'react';

import { Flex, Text } from '@chakra-ui/react';

import AuxiliaryActivitiesGroupTable from './AuxiliaryActivitiesGroupTable';
import EquipmentGroupTable from './EquipmentGroupTable';
import FixedTimeGroupTable from './FixedTimeGroupTable';
import LaborGroupTable from './LaborGroupTable';
import MaterialGroupTable from './MaterialGroupTable';
import {
  auxiliaryActivitiesGroupTableMock,
  equipmentGroupTableMock,
  fixedTimeGroupTableMock,
  laborGroupTableMock,
  materialGroupTableMock,
  timeOfTransportGroupTableMock,
} from './mocks';
import TimeOfTransportGroupTable from './TimeOfTransportGroupTable';

const DNITCompositionData: React.FC = () => {
  return (
    <Flex my={8} direction="column" gap={4}>
      <EquipmentGroupTable data={equipmentGroupTableMock} />
      <LaborGroupTable data={laborGroupTableMock} />
      <MaterialGroupTable data={materialGroupTableMock} />
      <AuxiliaryActivitiesGroupTable data={auxiliaryActivitiesGroupTableMock} />
      <Flex justify="flex-end">
        <Flex
          fontSize="xs"
          fontWeight="semibold"
          paddingX={2}
          marginY={-2}
          minWidth={{ base: 'auto', md: '200px' }}
          justify={{ base: 'flex-start', md: 'space-between' }}
          gap={{ base: 1, md: 6 }}
        >
          <Text as="span">Subtotal:</Text>
          <Text as="span">R$16.206,4815</Text>
        </Flex>
      </Flex>
      <FixedTimeGroupTable data={fixedTimeGroupTableMock} />
      <TimeOfTransportGroupTable data={timeOfTransportGroupTableMock} />
    </Flex>
  );
};

export default DNITCompositionData;
